import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { path as productPage } from "@faire/web-api--source/routes/www/product/productToken";
import qs from "query-string";
export var ProductPagePaths;
(function(ProductPagePaths) {
    function index(productToken) {
        var queries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (isPrerender()) {
            // For SEO discoverability, we want to render product tile urls without any
            // query parameters so that google bot can see the canonical path to product page
            return productPage(productToken);
        }
        return productPage(productToken, queries);
    }
    ProductPagePaths.index = index;
    (function(index) {
        // FIXME: This isn't needed. Put params on backend definition, use QueryParameters.parse
        index.parseSearch = function(locationSearch) {
            return qs.parse(locationSearch);
        };
    })(index = ProductPagePaths.index || (ProductPagePaths.index = {}));
})(ProductPagePaths || (ProductPagePaths = {}));
